export default __webpack_public_path__ + "static/media/25.99e8b21b.png";